<template>
    <div>
        <feature-form
            :is-feature-form-sidebar-active.sync="isFeatureFormSidebarActive"
            :feature-data="featureData"
            @refetch-data="refetchFeatureData" 
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                                variant="primary"
                                @click="updateFeature()"
                            >
                                <span class="text-nowrap">Add Feature</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                v-if="!Features.length"
                :items="Features"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>
            <table v-else class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="col in tableColumns" :key="col.key">
                        {{col.label}}
                    </th>
                    </tr>
                </thead>
                <draggable v-model="Features" tag="tbody" hadle=".handle" @change="updateOrdering()">
                <tr v-for="(item, index) in Features" :key="index">
                    <th scope="row" class="pl-2">
                        <MenuIcon icon="MenuIcon"/> 
                    </th>
                    <td class="pl-2">
                        <b-img
                            :src="item.icon_path?item.icon_path:require(`@/assets/images/no-image.png`)"
                            height="75"
                            width="75"
                            class="rounded m-0"
                        />
                    </td>
                    <td class="pl-2">
                        <span v-html="item.name[currentLocale]"></span>
                    </td>
                    <!-- <td class="pl-2">
                        <span v-html="item.slug[currentLocale]"></span>
                    </td> -->
                    <td class="pl-2">
                        <b-badge
                            pill
                            :variant="`light-${resolveFeatureStatusVariant(item.is_active)}`"
                            class="text-capitalize"
                        >
                            {{ resolveFeatureStatusnameVariant(item.is_active) }} 
                        </b-badge>
                    </td>
                    <td class="pl-2">
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateFeature(item)" variant="outline-success">Edit</b-button>
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                    </td>
                </tr>
                </draggable>
            </table>

            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span v-if="Features.length" class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                        <span v-else class="text-muted">Showing {{ 0 }} to {{ 0 }} of {{ 0 }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalFeatures"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup,
    BFormCheckbox, BImg,
} from 'bootstrap-vue';
import draggable from 'vuedraggable'
import { ref,onUnmounted } from '@vue/composition-api'
import store from '@/store'
import Ripple from 'vue-ripple-directive';
import roomStoreModule from '../roomStoreModule';
import useFeatureList from '../feature-list/useFeatureList'
import { MenuIcon } from 'vue-feather-icons'
import FeatureForm from '../feature-list/FeatureForm.vue'
    
export default {
    components: {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
        draggable, MenuIcon, BImg, FeatureForm,
    },
    directives: {
        'b-modal': VBModal,
        Ripple
    },
    computed: {
        currentLocale() {
            return  this.$i18n.locale;
        },
    },
    setup() {
        const CAT_STORE_MODULE_NAME = 'app-room';
        if (!store.hasModule(CAT_STORE_MODULE_NAME)) store.registerModule(CAT_STORE_MODULE_NAME, roomStoreModule)
        onUnmounted(() => {
            if (store.hasModule(CAT_STORE_MODULE_NAME)) store.unregisterModule(CAT_STORE_MODULE_NAME)
        });

        const {
            dataMeta,
            tableColumns,
            isFeatureFormSidebarActive,
            refetchFeatureData,
            fetchFeatureData,
            updateFeature,
            resolveFeatureStatusVariant,
            resolveFeatureStatusnameVariant,
            refFeatureListTable,
            Features,
            sortBy,
            isSortDirDesc,
            totalFeatures,
            featureData,
            deleteData,
            t,
            perPage,
            currentPage,
            searchQuery,
            updateOrdering,
        } = useFeatureList()

        fetchFeatureData()

        return {
            isFeatureFormSidebarActive,
            featureData,
            refetchFeatureData,
            fetchFeatureData,
            updateFeature,
            searchQuery,
            refFeatureListTable,
            Features,
            tableColumns,
            sortBy,
            isSortDirDesc,
            resolveFeatureStatusVariant,
            resolveFeatureStatusnameVariant,
            dataMeta,
            totalFeatures,
            currentPage,
            deleteData,
            perPage,
            t,
            updateOrdering,
        }
    },
    methods:{
        deleteconfirm(id){
            this.$bvModal
                .msgBoxConfirm(`Please confirm that you want to delete icon ID = ${id}`, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                    this.deleteData(id)
                }
            })
        },
    }
}
</script>